import { Flex } from '@chakra-ui/react';
import Card from 'components/card/Card';
import FormCadastrarEditarTipologia from 'components/forms/FormCadastrarEditarTipologia';
import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import { useContext, useEffect, useMemo } from 'react';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

export default function CadastrarTipologias() {
	const { setters } = useContext(SidebarHelpContext);
	const { setDataSidebar } = setters;

	const helpTipologiaParadas = useMemo(
		(): ISidebarHelp => ({
			title: 'Cadastrar Parada',
			firstParagraph:
				'Para cadastrar uma nova parada informe o nome do Parada, e se ela é do tipo programada (prevista) ou não programada.',
			secondParagraph:
				'Algumas paradas são comuns em diversos setores industriais, por isso a easy360 já retorna automaticamente uma lista de paradas.',
			firstLink: URL_CT360,
			secondLink: URL_FALE_CONOSCO,
		}),
		[]
	);

	useEffect(() => {
		setDataSidebar(helpTipologiaParadas);
	}, [helpTipologiaParadas, setDataSidebar]);

	const formInitialState = {
		tipologia_parada: null,
		programada: false,
		tempo_de_parada: '00:00:00',
	};

	return (
		<Flex
			direction='column'
			pt={{ sm: '125px', lg: '75px' }}
		>
			<Card px='0px'>
				<FormCadastrarEditarTipologia initialState={formInitialState} />
			</Card>
		</Flex>
	);
}
